import { useEffect, useState } from 'react';

import { useAuth } from '@features/auth/hooks/useAuth';
import { useDeviceAuthMutation } from '@features/shared/api/fastgames';

export function useAnonymousGameToken(
  gameId: string | undefined | null,
  deviceId: string,
  anonymousSecret: string | null,
) {
  const { isAuthenticated } = useAuth();
  const mutation = useDeviceAuthMutation(deviceId, anonymousSecret);
  const [token, setToken] = useState<{ token: string; gameId: string } | undefined>();

  useEffect(() => {
    const getToken = mutation.mutateAsync;

    // не нужен
    if (!gameId || isAuthenticated) {
      setToken(undefined);
      return;
    }

    //  уже есть
    if (token && token.gameId === gameId) return;

    // запрос (с проверкой актуальности)
    let stale = false;
    getToken(gameId).then(({ accessToken }) => {
      if (!stale) setToken({ token: accessToken, gameId });
    });

    return () => {
      stale = true;
    };
  }, [gameId, token, isAuthenticated, mutation.mutateAsync]);

  return {
    customAccessToken: token?.token,
    isPending: mutation.isPending,
    isError: mutation.isError,
  };
}
